import { Link } from 'react-router';

export default function NotFound() {
  return (
    <div className="rounded-lg border border-dashed border-line-strong bg-surface py-16 text-center">
      <h1 className="text-base font-semibold text-ink">Page not found</h1>
      <p className="mt-1 text-sm text-ink-muted">That URL does not match anything in the workspace.</p>
      <Link to="/tickets" className="btn-primary mt-4">Back to tickets</Link>
    </div>
  );
}
